<template>
  <div class="sp-item-quanitity-wrapper d-flex flex-column fc-black-06 fs-14">
    <!-- 产品名称 -->
    <div
      class="mb-1 fc-black-09 fb-650 name"
      :class="[nameFont]"
      v-if="showName && product.productInfo"
      :title="product.productInfo.nameEn"
    >
      {{ product.productInfo.nameEn }}
    </div>
    <!-- code -->
    <div v-if="showCode">
      <shopmall-product-code :product="product"></shopmall-product-code>
    </div>
    <!-- <div
      v-if="showCode"
      class="sp-link-noline mb-1 fs-14"
      @click="
        navigateTo(
          `/product/${product.productInfo.code}-${product.productInfo.nameEn}`
        )
      "
    >#{{ product.productInfo.code }}</div>-->
    <!-- item color -->
    <div class="my-2 d-flex" v-if="product.specsType === 'Color'">
      <span class="label color-label">Item Color</span>
      <span class="fc-black-09 fb-650">{{ product.specsValue || "-" }}</span>

      <shopmall-tip
        message="This SKU is no longer available."
        v-if="!product.specsValid && tips"
      ></shopmall-tip>
    </div>
    <!-- QTY -->
    <div v-if="product.productPrice">
      <div class="d-flex mb-2">
        <div class="label">Qty</div>
        <div>
          <span class="fc-black-09 fb-650">{{ product.quantity }}&nbsp;</span>
          <span class="ml-1" v-if="store?.userInfo?.status == 1"
            >(${{ product.productPrice.productPrice }}&nbsp;ea)</span
          >
          <span class="ml-1" v-else
            >(${{ product.productPrice.productPrice }}&nbsp;(C)&nbsp;ea)</span
          >
          <shopmall-tip
            v-if="product?.productPrice?.overBoxLimit && tips"
            message="Order limit exceeded for this item."
          ></shopmall-tip>
        </div>
      </div>
      <!-- 规格列表 -->
      <div v-for="spec in product.productSpecs || []" class="d-flex">
        <div class="label"></div>
        <div
          class="d-flex flex-1-0 justify-space-between fs-14"
          v-if="spec.specsValue"
        >
          <span style="flex: 1">{{ spec.specsValue }}:</span>
          <span style="flex: 3">
            {{ spec.quantity }}
            <shopmall-tip
              message="This SKU is no longer available."
              v-if="!spec.specsValid && tips"
            ></shopmall-tip>
          </span>
        </div>
      </div>
      <!-- send -->
      <div
        class="d-flex align-center space-start flex-1-0"
        v-if="
          !['BLANK', 'SAMPLE'].includes(
            product.productPrinting.printingWay.toUpperCase()
          ) && showSample
        "
      >
        <div
          class="mr-1 d-flex align-center"
          v-if="!detail || (detail && product.sampleFlag == 1)"
        >
          <div class="mr-1">
            <v-checkbox
              :label="sampleText"
              class="fc-black-09 fs-14"
              v-model="product.sampleFlag"
              :true-value="1"
              :false-value="0"
              :disabled="expire || detail"
              @change="changeSampleFlag"
            ></v-checkbox>
          </div>

          <div>
            <shopmall-physical-sample-tip></shopmall-physical-sample-tip>
          </div>
        </div>
      </div>

      <div v-if="showMoney" class="mt-4 d-flex align-center">
        <!-- money -->
        <span class="label">Total</span>
        <shopmall-text-loading v-if="totalLoading" :loadingType="2" />
        <span v-else>
          <span class="fc-black-09 fs-14 text-right fb-650">
            $&nbsp;{{ totalInfo.total }}
            <shopmall-product-money-tip
              :product="totalInfo.product"
            ></shopmall-product-money-tip>
          </span>
        </span>
      </div>
      <!-- 操作按钮 -->
      <div v-if="!detail" class="mt-4">
        <v-btn
          class="mr-4"
          @click="remove()"
          size="small"
          variant="outlined"
          v-if="showRemove"
          >Remove</v-btn
        >
        <v-btn
          color="primary"
          @click="edit"
          size="small"
          v-if="!expire && showEditQty && !editOutlined"
          >Edit Qty</v-btn
        >
        <v-btn
          variant="outlined"
          @click="edit"
          size="small"
          v-if="!expire && showEditQty && editOutlined"
          >Edit Qty</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { cartInteractor } from "~/core";
import { useUserStore } from "~/stores";
const store = useUserStore();
// 定义remove 和editQty自定义事件
const emits = defineEmits(["remove", "edit-qty", "reget-detail"]);
// 定义props etail 类型是Boolean，默认值是false
const props = defineProps({
  totalLoading: {
    type: Boolean,
    default: false
  },
  detail: {
    type: Boolean,
    default: false
  },
  product: {
    type: Object,
    required: true
  },
  sampleText: {
    type: String,
    default: "Send me a physical sample"
  },
  expire: {
    type: Boolean,
    default: false
  },
  tips: {
    type: Boolean,
    default: true
  },
  showRemove: {
    type: Boolean,
    default: true
  },
  showEditQty: {
    type: Boolean,
    default: true
  },
  valueStyle: {
    type: Object,
    default: () => ({})
  },
  showMoney: {
    type: Boolean,
    default: false
  },
  totalInfo: {
    type: Object,
    default: () => ({})
  },
  editOutlined: {
    type: Boolean,
    default: false
  },
  showName: {
    type: Boolean,
    default: true
  },
  showCode: {
    type: Boolean,
    default: true
  },
  nameFont: {
    type: String,
    default: "fs-14"
  },
  showSample: {
    type: Boolean,
    default: true
  }
});

const { $Confirm, $Message, $Utils, $BaseClickBurying, $MallPageName, $ClickSource, $Reporter } = useNuxtApp();

// remove
const cart = useCart();
const remove = () => {
  $Confirm("Are you sure  to remove this item from your cart?").then(
    async result => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
       
        const [res, err] = await cartInteractor.deleteCartApi(props.product.id);
        if (err === null) {
          $BaseClickBurying($MallPageName.mallMyCart, $ClickSource.mallMyCartRemove,)
          $Reporter.click({event: 'e_my_cart_remove'})
          $Message.success("Deletion completed");
          emits("reget-detail", props.product.id);
          const cart = useCart();
          cart.initCartData(false);
        }
      }
    }
  );
};

const edit = () => {
  emits("edit-qty", props.product);
};

const changeSampleFlag = async () => {
  const { id: cartId, sampleFlag } = props.product;
  let [res, err] = await cartInteractor.updateSampleFlagApi({
    cartId,
    sampleFlag
  });
  if (err === null) {
    emits("reget-detail", sampleFlag);
  }
};

const changeSpecValue = async () => {
  const { id: cartId, specsType, specsValue } = props.product;
  let [res, err] = await cartInteractor.updateSpecsApi({
    cartId,
    specsType,
    specsValue
  });
  if (err === null) {
    emits("reget-detail");
  }
};
</script>

<style lang="scss" scoped>
.sp-item-quanitity-wrapper {
  width: 100%;
  .label {
    display: inline-block;
    width: 115px;
    &.color-label {
      position: relative;
    }
  }

  :deep(.v-label) {
    font-size: 13px !important;
  }
  :deep(.color-select.v-input) {
    display: inline-block;
    width: 105px !important;
  }
  :deep(.v-input:not(.v-textarea).v-select .v-field__input) {
    height: 30px !important;
  }
  :deep(.v-input__details) {
    display: none !important;
  }
}
</style>
